import { clearServiceWorkerCaches } from '../serviceWorker';

export const initImportWithRetry = _dialog => {
  window.restartDialog = _dialog;
};

export const importWithRetry = componentImport => async () => {
  try {
    const component = await componentImport();

    window.localStorage.setItem('page-has-been-force-refreshed', 'false');

    return component;
  } catch (error) {
    console.log('Error on load chunk, restart app', error);

    const reloadApp = async () => {
      window.localStorage.setItem('page-has-been-force-refreshed', 'true');
      try {
        await clearServiceWorkerCaches();
      } catch (e) {
        // ignore cache cleanup failures
      }
      window.location.reload();
    };

    if (window.restartDialog) {
      window.restartDialog(reloadApp);
    } else {
      reloadApp();
    }
    return null;
  }
};
